const General = Vue.component('general', {
    template: `
        <div>
            <div class="row title">
                <div class="col">
                    <h4>
                        {{ $language.familyNum.replace('[FAMILYNUMBER]', family) }}
                    </h4>
                </div>
            </div>
            <div class="main" id="general">

                <div class="row">
                    <div class="col">
                        <b>{{ $language.title }}: </b>
                        <div v-html="familyInformation.Title"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <b>{{ $language.abstract }}: </b>
                        <div v-html="familyInformation.Abstract"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <b>{{ $language.pa }}: </b>

                        <router-link class="link" active-class="currentPage" :to="'/' + family + '/assignee'">
                            {{ familyInformation.ProbableAssignee }}
                        </router-link>

                        <span v-if="hasLinks">
                            |
                        </span>
                        <companylinks ref="companylinks" v-bind:company="familyInformation.ProbableAssignee" class="companyLinks"></companylinks>
                    </div>
                </div>
                <div class="row">
                    <div class="col">

                        <b>{{$language.numberOfPublications}}: </b>

                        {{ familyInformation.numberofpublications }}
                        &nbsp;
                        <b>{{ $language.citationsCount }}: </b>

                        {{ $language.backwards }}: {{ familyInformation.backwardCount }} | {{ $language.forwards }}: {{ familyInformation.forwardCount }}

                    </div>
                </div>
                <div class="row">
                    <div class="col">


                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr />
                    </div>
                </div>
                <div class="row" v-show="builtMap">
                    <div class="col-xl-2 col-lg-3">
                        <b>{{ $language.familyMap }}:</b>
                    </div>
                </div>
                <div class="row" v-show="builtMap">
                    <div class="col-12">
                        <div id="mapContainer"></div>
                    </div>
                    <div class="col-12 text-center tuto">
                        {{ $language.mapCaption }}
                    </div>
                </div>
            </div>
        </div>
    `,

    data: function() {
        return {
            familyInformation: {},
            jurisdictions: [],
            mapData: {},
            hasLinks: false,
            builtMap: false
        };
    },

    computed: {
        family() {
            return this.$route.params.family;
        }
    },

    mounted: function() {

        this.$store.commit('addLoadedComponent', 'General');

        this.$refs.companylinks.$on('fetched_links', () => {
            this.hasLinks = true;
        });

        EventBus.$on('newFamily', () => {
            this.onNewFamily();
        });
        this.onNewFamily();

    },

    methods: {

        onNewFamily() {
            this.builtMap = false;
            axios.get('?page=getData&action=getGeneralData', {
                    params: {
                        family: this.family
                    }
                })
                .then(response => {

                    let data = response.data;

                    this.familyInformation = {
                        Abstract: data.abstract,
                        Title: data.title,
                        ProbableAssignee: data.probablepa,
                        backwardCount: data.backwardcitationscount,
                        forwardCount: data.forwardcitationscount,
                        numberofpublications: data.numberofpublications,
                    };

                    this.$store.commit('storePA', data.probablepa);
                    this.$store.commit('hideLoading')


                })
                .catch(err => {
                    console.log(err);
                    this.$store.commit('hideLoading')

                });

            //get family jurisdictions
            axios.get('?page=getData&action=familyData', {
                    params: {
                        'family': this.family
                    }
                })
                .then((response) => {

                    var familyData = response.data;
                    var i = 0;

                    var mapData = {
                        dead: [],
                        applications: [],
                        grants: []
                    };

                    for (var cc in familyData) {
                        if (familyData.hasOwnProperty(cc)) {
                            if (familyData[cc].dead) {
                                mapData.dead.push({
                                    code: cc,
                                    z: familyData[cc].dead,
                                    name: countries.codes[cc]
                                });
                            }
                            if (familyData[cc].grants) {
                                mapData.grants.push({
                                    code: cc,
                                    z: familyData[cc].grants,
                                    name: countries.codes[cc]
                                });
                            }
                            if (familyData[cc].applications) {
                                mapData.applications.push({
                                    code: cc,
                                    z: familyData[cc].applications,
                                    name: countries.codes[cc]
                                });
                            }

                        }
                    }


                    this.mapData = mapData;

                    this.buildMap();

                })
                .catch(error => {
                    console.log(error);
                });

        },

        buildMap: function() {

            var map = Highcharts.mapChart('mapContainer', {
                chart: {
                    borderWidth: 0,
                    map: 'custom/world'
                },

                title: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                subtitle: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                legend: {
                    enabled: true
                },

                exporting: {
                    buttons: {
                        contextButton: {
                            symbol: 'url(./img/export.png)',
                            width: 24,
                            symbolX: 19.5,
                            symbolY: 18.5
                        }
                    }
                },

                mapNavigation: {
                    enabled: false,
                },

                navigation: {
                    buttonOptions: {
                        enabled: false
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                        name: 'Countries',
                        enableMouseTracking: true,
                        showInLegend: false
                    },
                    {
                        type: 'mapbubble',
                        name: 'Dead in this jurisdiction',
                        joinBy: ['iso-a2', 'code'],
                        data: this.mapData.dead,
                        minSize: 4,
                        maxSize: '12%',
                        tooltip: {
                            pointFormat: '{point.name} ({point.code}): {point.z}'
                        },
                        color: '#c0392b',
                        visible: false
                    },
                    {
                        type: 'mapbubble',
                        name: 'Applications (not granted) in this jurisdiction',
                        joinBy: ['iso-a2', 'code'],
                        data: this.mapData.applications,
                        minSize: 4,
                        maxSize: '12%',
                        tooltip: {
                            pointFormat: '{point.name} ({point.code}): {point.z}'
                        },
                        color: '#41699c'
                    },
                    {
                        type: 'mapbubble',
                        name: 'Grants in this jurisdiction',
                        joinBy: ['iso-a2', 'code'],
                        data: this.mapData.grants,
                        minSize: 4,
                        maxSize: '12%',
                        tooltip: {
                            pointFormat: '{point.name} ({point.code}): {point.z}'
                        },
                        color: '#27ae60'
                    }
                ]
            });
            this.builtMap = true;
        }
    }
});
